const COLORS_BY_RANK = ['#FF2D38', '#F97316', '#6366F1', '#10B981', '#0EA5E9'];

export const OTHER_COLOR = '#D1D5DB';
const FALLBACK_COLOR = '#9CA3AF';

export const colorForRank = (rank) => {
  if (rank < 0 || rank >= COLORS_BY_RANK.length) return FALLBACK_COLOR;
  return COLORS_BY_RANK[rank];
};

export const formatCount = (value) => {
  if (value == null || Number.isNaN(Number(value))) {
    return '0';
  }
  return new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(
    Number(value)
  );
};

export const formatPercent = (value) => {
  if (value == null || Number.isNaN(Number(value))) {
    return '0%';
  }
  return `${Number(value)}%`;
};
